<template>
  <div id="wrapper">
    <Nav :message="message" />
    <RevenueAccount />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import RevenueAccount from '@/components/revenue/RevenueAccount.vue'

export default {
  name: 'Revenue-Report',
  props: ['message'],
  components: {
    Nav,
    RevenueAccount
  }
}
</script>